
import { Vue, Component, Prop } from 'vue-property-decorator'

import PreviewLabelValue from '@/stories/preview-label-value/PreviewLabelValue.vue'
import TriggerVariableCard from '@/modules/notification-center/event-trigger/components/TriggerVariablesCard.vue'
import {
  SMSChannel,
  WhatsAppChannel,
  WhatsAppStatus
} from '@/modules/notification-center/event-trigger/types/triggerTypes'
import { isContentContainsVariables } from '@/modules/notification-center/event-trigger/utils/isContentContainsVariables'

@Component({
  name: 'SMSPreviewComponent',
  components: {
    PreviewLabelValue,
    TriggerVariableCard
  }
})
export default class SMSPreviewComponent extends Vue {
  @Prop({ type: Object, required: true })
  readonly channel!: SMSChannel | WhatsAppChannel

  @Prop({ type: Boolean, required: false, default: false })
  readonly loading!: boolean

  @Prop({ type: Array, required: false, default: [] })
  readonly variables!: string[]

  isContentContainsVariables = isContentContainsVariables

  get languages() {
    return [
      { code: 'en', label: 'En' },
      { code: 'ckb', label: 'Ckb' },
      { code: 'ar', label: 'Ar' }
    ]
  }

  get getWhatsAppAlertType() {
    const whatsappStatus = (this.channel as WhatsAppChannel).whatsappStatus
    switch (whatsappStatus) {
      case WhatsAppStatus.PENDING:
        return 'warning'
      case WhatsAppStatus.APPROVED:
        return 'success'
      case WhatsAppStatus.REJECTED:
        return 'error'
      default:
        return 'warning'
    }
  }

  get whatsAppIcon() {
    const whatsappStatus = (this.channel as WhatsAppChannel).whatsappStatus
    switch (whatsappStatus) {
      case WhatsAppStatus.PENDING:
        return 'fal fa-clock'
      case WhatsAppStatus.APPROVED:
        return 'fal fa-check-circle'
      case WhatsAppStatus.REJECTED:
        return 'fal fa-circle-xmark'
      default:
        return 'fal fa-clock'
    }
  }

  get whatsAppMessage() {
    const whatsappStatus = (this.channel as WhatsAppChannel).whatsappStatus
    switch (whatsappStatus) {
      case WhatsAppStatus.PENDING:
        return {
          type: 'warning',
          content: this.$t('label.triggerWhatsAppStatusPendingNote')
        }
      case WhatsAppStatus.APPROVED:
        return {
          type: 'success',
          content: this.$t('label.triggerWhatsAppStatusActiveNote')
        }
      case WhatsAppStatus.REJECTED:
        return {
          type: 'error',
          content: this.$t('label.triggerWhatsAppStatusRejectedNote')
        }
      default:
        return null
    }
  }
}
